import { Snackbar, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';

interface MapMessageProps {
  messages: string[];
  onClose?: () => void;
}

const MapMessage: React.FC<MapMessageProps> = ({ messages, onClose }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(messages.length > 0);
  }, [messages]);

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  if (messages.length === 0) return null;

  return (
    <Snackbar
      open={open}
      autoHideDuration={null}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        zIndex: 9999,
      }}
      message={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          {messages.map((msg, idx) => (
            <Box
              key={idx}
              sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
            >
              <span>{msg}</span>
            </Box>
          ))}
        </Box>
      }
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
    />
  );
};

export default MapMessage;
